﻿import isEqual from "lodash/isEqual";

type Fields = Record<string, unknown>;

const getChangedFields = (
  data: Fields | null | undefined,
  original: Fields | null | undefined
): Fields =>
  Object.keys(data ?? {}).reduce<Fields>((acc, key) => {
    if (!isEqual(data?.[key], original?.[key])) {
      acc[key] = data?.[key];
    }
    return acc;
  }, {});

export default getChangedFields;
